<div class="modal fade" :id="passwordUpdateModalId" tabindex="-1" role="dialog" aria-labelledby="passwordUpdateModalLabel'" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="passwordUpdateModalLabel">Change Password</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="alert alert-success alert-dismissible fade show" role="alert" v-if="showSuccessMessage">
                    {{successMessage}}
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="clearMessageAlerts">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="showErrorMessage">
                    {{errorMessage}}
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="clearMessageAlerts">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <form v-if="!showSuccessMessage && !showErrorMessage">
                    <div class="form-group">
                        <label>
                            Current Password
                        </label>
                        <div class="text-danger">
                            {{currentPassword.errorMessage}}
                        </div>
                        <input class="form-control" type="password" v-model="currentPassword.value">
                    </div>
                    <div class="form-group">
                        <label>
                            New Password
                        </label>
                        <div class="text-danger">
                            {{password.errorMessage}}
                        </div>
                        <input class="form-control" type="password" v-model="password.value">
                    </div>
                    <div class="form-group">
                        <label>
                            Confirm New Password
                        </label>
                        <div class="text-danger">
                            {{confirmPassword.errorMessage}}
                        </div>
                        <input class="form-control" type="password" v-model="confirmPassword.value">
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-success" @click="passwordUpdate" :disabled="loading" v-if="!showSuccessMessage && !showErrorMessage">SAVE</button>
                <button type="button" class="btn btn-secondary" data-dismiss="modal" v-if="!showSuccessMessage && !showErrorMessage" :disabled="loading">CLOSE</button>
                <button type="button" class="btn btn-secondary" :disabled="loading" v-if="showSuccessMessage || showErrorMessage" @click="onOkClick">OK</button>
            </div>
        </div>
    </div>
</div>